import { useSectionConditions } from '../../../../application/product/proposal/disclosure/conditions'
import { DisclosureConfig } from '../../../../state/configuration'

export const useRelevantDisclosures = (disclosures: DisclosureConfig[]) => {
  const conditions = useSectionConditions()

  return disclosures.filter((it) =>
    it.conditions
      ? it.conditions
          ?.map((it) => {
            return conditions(it)
          })
          .some((it) => it)
      : true,
  )
}
